import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  getGroupNameLibAsync,
  getGroupsByUserLibAsync,
  createGroupLibAsync,
  removeGroupLibAsync,
  assignUserToGroupLibAsync,
  assignRoleToGroupLibAsync,
} from 'src/redux/async/libraries/groupThunks'

const initialState = {
  groupsData: [],
  userGroupsData: [],
  createGroupData: [],
  removeGroupData: [],
  assignGroupData:[],
  assignRoleData:[],
  groupLoader: false,
  error: '',
  // groupCreationStatus: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
}

export const groupSlice = createSlice({
  name: 'groupLibraries',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
      // Fetch all groups
      builder.addMatcher(isAnyOf(getGroupNameLibAsync.pending), (state) => {
        state.groupLoader = true
      })
      builder.addMatcher(isAnyOf(getGroupNameLibAsync.fulfilled), (state, action) => {
        state.groupLoader = false
        state.groupsData = action.payload;
        state.error = ''
      })
      builder.addMatcher(isAnyOf(getGroupNameLibAsync.rejected), (state, action) => {
        state.groupLoader = false
        state.error = action.payload
      })

      // Fetch groups by user
      builder.addMatcher(isAnyOf(getGroupsByUserLibAsync.pending), (state) => {
        state.groupLoader = true
      })
      builder.addMatcher(isAnyOf(getGroupsByUserLibAsync.fulfilled), (state, action) => {
        state.groupLoader = false
        state.userGroupsData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(getGroupsByUserLibAsync.rejected), (state, action) => {
        state.groupLoader = false
        state.error = action.payload
      })


      // Create group
      builder.addMatcher(isAnyOf(createGroupLibAsync.pending), (state) => {
        state.groupLoader = true
      })
      builder.addMatcher(isAnyOf(createGroupLibAsync.fulfilled), (state, action) => {
        state.groupLoader = false
        state.createGroupData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(createGroupLibAsync.rejected), (state, action) => {
        state.groupLoader = false
        state.error = action.payload
      })


      // Remove group
      builder.addMatcher(isAnyOf(removeGroupLibAsync.pending), (state) => {
        state.groupLoader = true
      })
      builder.addMatcher(isAnyOf(removeGroupLibAsync.fulfilled), (state, action) => {
        state.groupLoader = false
        state.removeGroupData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(removeGroupLibAsync.rejected), (state, action) => {
        state.groupLoader = false
        state.error = action.payload
      })

      // Assign user to group
      builder.addMatcher(isAnyOf(assignUserToGroupLibAsync.pending), (state) => {
        state.groupLoader = true
      })
      builder.addMatcher(isAnyOf(assignUserToGroupLibAsync.fulfilled), (state, action) => {
        state.groupLoader = false
        state.assignGroupData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(assignUserToGroupLibAsync.rejected), (state, action) => {
        state.groupLoader = false
        state.error = action.payload
      })

      // Assign role to group
      builder.addMatcher(isAnyOf(assignRoleToGroupLibAsync.pending), (state) => {
        state.groupLoader = true
      })
      builder.addMatcher(isAnyOf(assignRoleToGroupLibAsync.fulfilled), (state, action) => {
        state.groupLoader = false
        state.assignRoleData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(assignRoleToGroupLibAsync.rejected), (state, action) => {
        state.groupLoader = false
        state.error = action.payload
      })
  }
})

export default groupSlice.reducer

